import PlainHero from '../../components/PlainHero/PlainHero';

const GoogleRegistrationPage = () => {
    return (
        <div>
            {/* <PlainHero
                heading="Registration"
                content="Please fill out the form below."
            /> */}
            <div className='d-xl-block d-none' style={{height:"180px"}}></div>
            <div
                style={{
                    backgroundImage: "url('/images/creatives/olevel-composite-bg.png')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: "contain",
                    padding: '20px'
                }}
            >
                {/* <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLSfv4l1ZtNc09YnO4HkY4yyNEd0WfmGv3WWFBnALej-xfgyq-g/viewform?embedded=true"
                    width="100%"
                    height="2130"
                    style={{ border: 'none', width: '100%' }}
                >
                    Loading…
                </iframe> */}
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLSdNkgyXt7ITcdIuex4hChUvHLPyPc7FLSQBOifwasPaFpfTvQ/viewform?embedded=true"
                    width="100%"
                    height="2130"
                    style={{ border: 'none', width: '100%' }}
                >
                    Loading…
                </iframe>
               
            </div>
        </div>
    );
};

export default GoogleRegistrationPage;